// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aam-auth-tg[data-v-b6f719bc]{display:flex;align-items:center;gap:6px;height:28px;padding:0 12px;min-height:0;box-sizing:border-box;font-size:14px;line-height:1.2;font-weight:700;text-transform:none;letter-spacing:-.015em;border-radius:100px;border-color:transparent;color:#fff;background:linear-gradient(90deg,#02b0e5,#00c3ff)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
